export const ACCESS_TOKEN_EXPIRES = 1; // days
export const REFRESH_TOKEN_EXPIRES = 7; // days
